<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <div
      :class="{
        'error-page flex h-[16.875rem] items-center justify-center bg-[#010710] py-16 text-www-color-white md:items-end': true,
      }"
    >
      <div
        :class="{
          'text-28px font-black leading-8 text-www-color-white lg:text-6xl lg:leading-[4.3125rem]': true,
        }"
      >
        404
      </div>
    </div>
    <div class="text-center">
      <p class="py-10 text-28px font-black leading-10 text-www-color-neutral-medium-dark">
        Page Not Found
      </p>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
// import { BuildTags } from '@onshape/www-inertia';
// interface Error {
//   statusCode: string;
// }
// const pathname = window && window.location ? window.location.href : useRoute().fullPath;

// const { error } = defineProps<{ error: Error }>();
// console.log('404.vue', { error, buildTags: BuildTags.detailed, pathname });

await useAsyncData('removePayloadPathname', async (nuxtApp) => {
  delete nuxtApp?.payload?.path;
  return true;
});
</script>

<style>
.error-page {
  background-image: linear-gradient(82.48deg, #010710 1.76%, #0c2441 68.84%);
}
</style>
